export const BREAKPOINTS = {
  sm: 640,
  md: 768,
  lg: 1024,
  xl: 1280,
  tws: 1348,
  xl2: 1536,
};
export const APP_BAR_CHECK_COOKIE = "appBarClosed";
export const APP_BAR_CHECK_HEADER = "X-App-Bar-Closed";

export const START_PAGE_SLUG = "index";
export const PLAY_PAGE_SLUG = "play";

export const INFINITE_SCROLL_ARTICLE_LIMIT = 10;
export const INFINITE_SCROLL_ITEMS_PER_FETCH = 1;
export const ITEM_FEED_LIMIT = 30;

export const INFINITE_SCROLL_CATEGORY_LIMIT = 30;

// Play
export const BORSLUNCH_SHOW_ID = "xDATcGU6kUHN5jrwaNSxLY";
export const EFN_DIREKT_SHOW_ID = "rCGu0i5Hlo3MxqjMqf9Wgb";

// Podcast
export const BORSLUNCH_PODCAST_SHOW_ID = "Nv1QADTUGhE5g6EB8xBVqj";
export const EFN_DIREKT_PODCAST_SHOW_ID = "E2EaNX25hQs0tp7aHm0VZl";

// ARTICLE
export const EFN_ANALYSIS_CATEGORY_ID = "IGC2aanuWkYY9Ci5NMMwFA";
export const EFN_REPORT_COMMENTS_CATEGORY_ID = "P35FZ4xhH6fYIgBsv5qor4";
export const EFN_COMMENTS_CATEGORY_ID = "vtJ9s0FkgEnlfXMvJ8fJ7c";

export const EFN_SCIENCE_CATEGORY_ID = "Q7w5M00z7SVitrZAychcWa";

export const EFN_SCIENCE_TAG_SLUG = "Vetenskap";

export const INDEX_BREAKING_ID = "core-index-just-nu";

export const APP_USER_AGENT = "EFN-app/";

export function isAppRequest(headers: Headers): boolean {
  const userAgent = headers.get("user-agent");
  return userAgent ? userAgent.startsWith(APP_USER_AGENT) : false;
}

export const APP_SUBSCRIBE_PATH = "/app-subscribe";

export const APP_SUBSCRIBE_SIKT_PATH = "/app-subscribe/sikt";

export const APP_SUBSCRIBE_LOGIN_PATH = "/app-subscribe/logga-in";

export function isAppSubscribeRequest(headers: Headers): boolean {
  return headers.get("x-url")?.startsWith(APP_SUBSCRIBE_PATH) ?? false;
}

export function isAppExternalCheckoutRequest(headers: Headers): boolean {
  return isAppSubscribeRequest(headers) && !isAppRequest(headers);
}

export function getAppSubscribeRedirectPath(
  url?: string | null,
): string | undefined {
  if (!url) return undefined;
  const frontendUrl = process.env.NEXT_PUBLIC_FRONTEND_URL;
  let parsed: URL;
  try {
    parsed = new URL(url, frontendUrl);
  } catch {
    return undefined;
  }
  if (frontendUrl && parsed.origin !== new URL(frontendUrl).origin) {
    return undefined;
  }
  if (
    parsed.pathname !== APP_SUBSCRIBE_PATH &&
    !parsed.pathname.startsWith(`${APP_SUBSCRIBE_PATH}/`)
  ) {
    return undefined;
  }
  return parsed.pathname + parsed.search;
}

export function getAppSubscribeLoginHref(headers: Headers): string {
  const path = headers.get("x-url") ?? APP_SUBSCRIBE_PATH;
  const search = headers.get("x-search") ?? "";
  return `${APP_SUBSCRIBE_LOGIN_PATH}?redirectUrl=${encodeURIComponent(path + search)}`;
}

export function getSubscribeBasePath(
  packageId: number,
  isAppSubscribe = false,
): string {
  if (isAppSubscribe) {
    return packageId === 4 ? APP_SUBSCRIBE_SIKT_PATH : APP_SUBSCRIBE_PATH;
  }
  return packageId === 4 ? "/prenumerera-sikt" : "/prenumerera";
}

export function isIosAppRequest(headers: Headers): boolean {
  const userAgent = headers.get("user-agent");
  return isAppRequest(headers) && !!userAgent?.includes("(iOS)");
}

export function getAppVersion(headers: Headers): string | null {
  const userAgent = headers.get("user-agent")?.trim();

  if (!userAgent) {
    return null;
  }

  if (!userAgent.startsWith(APP_USER_AGENT)) {
    return null;
  }

  const version = userAgent.substring(APP_USER_AGENT.length);
  return version || null;
}

export const SITEMAP_URL_LIMIT = 1000;

export const FM_PROMO_IMAGE_ID = "YerWWrS5GCxbPClYslUgTq";

export const LIVE_REPORT_LIMIT = 50;

export const THEME_COOKIE = "theme";

export const NYHETSBYRAN_DIREKT_AUTHOR_ID = "JKIcZ6A9xplFNzZ6KvC5YI";
